import CryptoJS from 'crypto-js';


export interface DecryptedAuthToken{
    authToken: string;
    rememberMe: boolean;
}


export function encrypt(data: DecryptedAuthToken, seed: string): string{
    const jsonString = JSON.stringify(data); 
    return CryptoJS.AES.encrypt(jsonString, seed).toString(); 
}

export function decrypt(encryptedData: string, seed: string): DecryptedAuthToken{
    const bytes = CryptoJS.AES.decrypt(encryptedData, seed);
    const jsonString = bytes.toString(CryptoJS.enc.Utf8); 
    return JSON.parse(jsonString);
}